"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
interface ChatFooterProps {
  variant?: "hero" | "conversation";
}
export function ChatFooter(t0) {
  const $ = _c(30);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "hero" : t1;
  const {
    t
  } = useTranslation();
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(true);
  if (variant === "conversation") {
    let t2;
    if ($[0] !== t) {
      t2 = t("footer.aiNotice", {
        defaultValue: "ChatbotGPT is AI and can make mistakes."
      });
      $[0] = t;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t2) {
      t3 = <div className="flex h-10 shrink-0 items-center justify-center text-xs text-muted-foreground select-none">{t2}</div>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("footer.privacyPolicy", {
      defaultValue: "Privacy Policy"
    });
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <a href="https://chatbotgpt.app/privacy-policy" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-foreground">{t2}</a>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("footer.termsAndConditions", {
      defaultValue: "Terms and Conditions"
    });
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <a href="https://chatbotgpt.app/member-tos-page" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-foreground">{t4}</a>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsDisclaimerOpen(_temp);
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("footer.disclaimer", {
      defaultValue: "Disclaimer"
    });
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `h-3.5 w-3.5 transition-transform duration-200 ${isDisclaimerOpen ? "rotate-180" : ""}`;
  let t9;
  if ($[15] !== t8) {
    t9 = <ChevronDown className={t8} />;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t9) {
    t10 = <button type="button" onClick={t6} className="inline-flex items-center gap-1 font-medium text-foreground transition-colors hover:opacity-70">{t7}{t9}</button>;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t3 || $[22] !== t5) {
    t11 = <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-1">{t3}{t5}{t10}</div>;
    $[20] = t10;
    $[21] = t3;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isDisclaimerOpen || $[25] !== t) {
    t12 = isDisclaimerOpen ? <p className="mx-auto mt-2 max-w-2xl leading-relaxed">{t("footer.disclaimerText", {
        defaultValue: "ChatbotGPT is not affiliated with, endorsed by, or sponsored by OpenAI, Anthropic, Google, or their respective AI products. All trademarks are the property of their respective owners."
      })}{" "}<a href="https://chatbotgpt.app/disclaimer" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{t("footer.learnMore", {
          defaultValue: "Learn More"
        })}</a></p> : null;
    $[24] = isDisclaimerOpen;
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t11 || $[28] !== t12) {
    t13 = <footer className="shrink-0 px-4 pb-3 pt-2 text-center text-xs text-muted-foreground select-none">{t11}{t12}</footer>;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp(open) {
  return !open;
}